import { useRef, useEffect } from 'react';
var DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function useClickOutside(handler, events, nodes) {
    var ref = useRef();
    useEffect(function() {
        var listener = function(event) {
            var target = (event != null ? event : {}).target;
            if (Array.isArray(nodes)) {
                var shouldIgnore = (target == null ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
                var shouldTrigger = nodes.every(function(node) {
                    return !!node && !event.composedPath().includes(node);
                });
                shouldTrigger && !shouldIgnore && handler();
            } else if (ref.current && !ref.current.contains(target)) {
                handler();
            }
        };
        (events || DEFAULT_EVENTS).forEach(function(fn) {
            return document.addEventListener(fn, listener);
        });
        return function() {
            (events || DEFAULT_EVENTS).forEach(function(fn) {
                return document.removeEventListener(fn, listener);
            });
        };
    }, [
        ref,
        handler,
        nodes
    ]);
    return ref;
}
export { useClickOutside }; //# sourceMappingURL=use-click-outside.js.map
